// extracted by mini-css-extract-plugin
module.exports = {"main-component":"gameIncomplete_main-component__Fq6Cc"};